import React, { useState } from 'react';
import { Fab, CircularProgress, Tooltip } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { API_BASE } from '../../config/config';

const ExportConfig = ({ sx }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/configdata/meters`);

      if (!res.ok) {
        throw new Error(`Failed to export: ${res.status}`);
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;

      const timestamp = new Date()
        .toISOString()
        .replace(/[-:]/g, '')
        .replace(/\..+/, '')
        .replace('T', '_');

      link.download = `export_config_${timestamp}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Export failed:', err);
      alert('Failed to export meter data.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Export Config">
      <Fab
        size="small"
        sx={sx}
        onClick={handleExport}
        disabled={loading}
        aria-label="Export Config"
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <FileDownloadIcon fontSize="small" />
        )}
      </Fab>
    </Tooltip>
  );
};

export default ExportConfig;
